import { useEffect, useState } from 'react';
import { toast } from 'material-react-toastify';
import { Box, Button, ButtonProps, Tooltip } from '@mui/material';
import LanguageIcon from '@mui/icons-material/Language';
import { getFeURL } from '../../api/Settings';
import { sharedStyles } from '../../utils/Style';

type OpenInFrontendProps = ButtonProps & {
  path: string;
  slug: string;
  isActive: boolean;
};

export const OpenInFrontend = ({
  path,
  slug,
  isActive,
  ...props
}: OpenInFrontendProps) => {
  const [feURL, setFeURL] = useState('');

  useEffect(() => {
    getFeURL()
      .then((url) => setFeURL(url))
      .catch((err) => toast.error(err.message));
  }, []);

  if (!feURL) {
    return null;
  }

  const handleClick = () => {
    const url = `${feURL}/${path}/${slug}`;
    window.open(url, '_blank');
  };

  const button = (
    <Button
      variant='contained'
      size='small'
      startIcon={<LanguageIcon />}
      disabled={!isActive}
      onClick={handleClick}
      sx={{ ...sharedStyles.buttonText }}
      {...props}
    >
      Görüntüle
    </Button>
  );

  return isActive ? (
    button
  ) : (
    <Tooltip title='Hedef sayfa inaktif olduğu için sitede görüntülenemez'>
      <Box>{button}</Box>
    </Tooltip>
  );
};
